import { useCallback, useMemo } from 'react';
import {
  SelectionAdapter,
  SelectionAdapterHook,
} from 'src/components/DataTable/types/DataTableSelection';
import { useGetEmployeeGroupsSelections } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeGroupsWrapper/hooks/useGetEmployeeGroupsSelections';
import { useUpdateEmployeeGroupsSelections } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeGroupsWrapper/hooks/useUpdateEmployeeGroupsSelections';
import { transformGroupsToIds } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeGroupsWrapper/employeeGroupsSelection.utils';

export interface EmployeeGroupsSelectionAdapterConfig {
  corpId: string;
  employeeId: string;
}

export function createEmployeeGroupsSelectionAdapter(
  config: EmployeeGroupsSelectionAdapterConfig
): SelectionAdapterHook {
  return function useEmployeeGroupsSelectionAdapterHook(): SelectionAdapter {
    const { corpId, employeeId } = config;

    const {
      groups,
      isLoading: isFetching,
      fetch: fetchSelections,
    } = useGetEmployeeGroupsSelections({ corpId, employeeId });

    async function handleSuccess(): Promise<void> {
      await fetchSelections();
    }

    const { updateSelections, isSaving } = useUpdateEmployeeGroupsSelections({
      corpId,
      employeeId,
      onSuccess: handleSuccess,
    });

    const save = useCallback(
      async (selections: string[]): Promise<void> => {
        await updateSelections(selections);
      },
      [updateSelections]
    );

    const initialSelections = useMemo(
      () => transformGroupsToIds(groups),
      [groups]
    );

    return {
      initialSelections,
      isLoading: isFetching || isSaving,
      fetch: fetchSelections,
      save,
    };
  };
}
